import React, {useContext} from 'react';

import Pagination from "components/WMS/List/Pagination";
import ListingEmptyState from "components/Product/Table/ListingEmptyState";

import useOrderList from "../../OrderTable/useOrderList";

import {OrderListContext} from "views/oms/OrderList/context/OrderListContext";

import OrderCard from "./OrderCard";
import OrderCardSkeleton from "./OrderCardSkeleton";

function OrderCardsList() {
    const {retrieved, loading, pageCount, handlePageChange, currentPage, paginationKey} = useOrderList();

    const {search, setSearch, selectedFilters, setSelectedFilters} = useContext(OrderListContext);

    const hasActiveSearchOrFilters = search.trim().length > 0 || selectedFilters.length > 0;

    function handleResetSearchAndFilters() {
        setSearch('');
        setSelectedFilters([]);
    }

    return (
        <div>
            {loading ? (
                <OrderCardSkeleton />
            ) : retrieved.length === 0 ? (
                hasActiveSearchOrFilters ? (
                    <ListingEmptyState
                        titleId="oms.order.list.noResult.title"
                        descriptionId="oms.order.list.noResult.description"
                        ctaLabelId="oms.order.list.noResult.cta"
                        ctaVariant="secondary"
                        onCtaClick={handleResetSearchAndFilters}
                    />
                ) : (
                    <ListingEmptyState
                        titleId="oms.order.list.emptyPeriod.title"
                        descriptionId="oms.order.list.emptyPeriod.description"
                    />
                )
            ) : (
                retrieved.map((order) => (
                    <OrderCard key={order.id} order={order} />
                ))
            )}

            <Pagination
                key={paginationKey}
                pageCount={pageCount}
                currentPage={currentPage}
                handlePageChange={handlePageChange}
                showPageCount={false}
            />
        </div>
    );
}

export default OrderCardsList;
